import SiteMessagesInstance from '../../components/site-messages'

export class StepAfterSetupNameSensor {
  constructor (onboarding) {
    this.onboarding = onboarding;
  }

  id = "after_setup_name_sensor";
  title = "Setup Complete";

  template = `
  <div class="onboarding-step" data-for="after_setup_name_sensor">

    <p class="onboarding-guide-instruction-large medium-text-center">
      <b>Success!</b> We've added the Temp Stick to your account!
    </p>

    <div class="onboarding-guide-instruction medium-text-center">
      Double check your sensor's name and ensure that it's set to something helpful
    </div>

    <div class="onboarding-guide-instruction-smaller text--small text--grey" style="margin-top: -10px; text-align: center;">
      Examples: Living Room, Server #123, Breakroom, or Garage Freezer
    </div>

    <label>
      Sensor Name:
      <input type="text" name="sensor_name" placeholder="Put in a name for your sensor" value=""
             autocomplete="off" autocapitalize="none" autocorrect="off" spellcheck="false">
    </label>

    <div class="onboarding-name-sensor-btn-container">
      <div class="onboarding-name-sensor-btn-container__btn is-active">
        <button type="button" class="button button--medium" data-for="save_sensor_name">
          Save and Finish
        </button>

        <button type="button" class="button button--blue-outline" data-for="save_sensor_name_add_another">
          Save and Add Another Temp Stick
        </button>

        <div class="onboarding-save-sensor-message"></div>
      </div>
    </div>

  </div>
  `;

  onBack = () => {
    window.location.href = window.site.home + '/sensors';
  }

  // The update endpoint requires send_interval / alert_interval on every save,
  // so read the interval registration gave this sensor instead of hardcoding
  // one that could quietly downgrade an account with a different default.
  DEFAULT_SEND_INTERVAL = 3600;

  sendIntervalRequest = null;

  loadSendInterval = () => {

    if (this.sendIntervalRequest) {
      return this.sendIntervalRequest;
    }

    if (!this.onboarding.sensor || !this.onboarding.sensor.sid) {
      return Promise.resolve(this.DEFAULT_SEND_INTERVAL);
    }

    this.sendIntervalRequest = window.apiRequest('get', `/sensor/${encodeURIComponent(this.onboarding.sensor.sid)}`)
      .then(res => {

        const send_interval = (res && res.data) ? parseInt(res.data.send_interval, 10) : NaN;

        if (isNaN(send_interval) || send_interval <= 0) {
          return this.DEFAULT_SEND_INTERVAL;
        }

        return send_interval;

      })
      .catch(() => this.DEFAULT_SEND_INTERVAL);

    return this.sendIntervalRequest;
  }

  onActivate = () => {

    this.loadSendInterval();

    this.$saveSensorMessage.removeClass('is-active is-error');
    this.$saveSensorMessage.html('');

    this.$saveNameBtn.removeAttr('disabled');
    this.$saveAddAnotherBtn.removeAttr('disabled');

    if(this.onboarding.sensorName && this.onboarding.sensorName.length > 0) {
      this.$sensorName.val(this.onboarding.sensorName);
    } else if (this.onboarding.sensor && this.onboarding.sensor.sid) {
      const currentValue = this.$sensorName.val() ? this.$sensorName.val().trim() : '';

      if (!currentValue) {
        this.$sensorName.val(this.onboarding.sensor.sid);
      }
    }

  }

  bindActions = () => {

    this.$saveBtnContainer = $(this.onboarding.container).find('.onboarding-name-sensor-btn-container');
    this.$btnContainer = this.$saveBtnContainer.find('.onboarding-name-sensor-btn-container__btn');

    this.$saveNameBtn = $(this.onboarding.container).find('button[data-for="save_sensor_name"]');
    this.$saveAddAnotherBtn = $(this.onboarding.container).find('button[data-for="save_sensor_name_add_another"]');

    this.$sensorName = $(this.onboarding.container).find('input[name="sensor_name"]');
    this.$saveSensorMessage = $(this.onboarding.container).find('.onboarding-save-sensor-message');

    const saveSensor = async (redirectToSetup) => {

      if (!this.onboarding.sensor || !this.onboarding.sensor.sid) {
        return;
      }

      this.$saveNameBtn.attr('disabled', true);
      this.$saveAddAnotherBtn.attr('disabled', true);

      this.$saveSensorMessage.removeClass('is-error');

      if (!this.$saveSensorMessage.hasClass('is-active')) {
        this.$saveSensorMessage.addClass('is-active');
      }

      this.$saveSensorMessage.html('Saving...');

      const send_interval = await this.loadSendInterval();

      let sensorData = {
        sensor_name: this.$sensorName[0].value.trim(),
        use_alert_interval: 0,
        send_interval,
        // no alert interval yet, so it matches the normal check-in interval
        alert_interval: send_interval,
      };

      if (this.onboarding.sensor.hasTc && this.onboarding.sensor.hasTc === true) {
        if (this.onboarding.sensor.probe_enabled && this.onboarding.sensor.probe_enabled === true) {
          sensorData["TC_M"] = 1;
        } else {
          sensorData["TC_M"] = 0;
        }

        if (this.onboarding.sensor.probe_type) {
          sensorData["TC_TYPE"] = this.onboarding.sensor.probe_type;
        }

        if (this.onboarding.sensor.probe_skin) {
          sensorData["TC_SKIN"] = this.onboarding.sensor.probe_skin;
        }
      }

      const goToSetupQuickAdd = () => {
        try {
          if (window && window.localStorage) {
            window.localStorage.setItem(
              'tempstick_onboarding_quick_add',
              JSON.stringify({
                sensor_version: this.onboarding.sensor_version,
                saved_at: Date.now()
              })
            );
          }
        } catch (e) {
          // ignore
        }

        const sv = this.onboarding.sensor_version || "v2";
        window.location.href = window.site.home + "/setup?quick_add=1&sensor_version=" + encodeURIComponent(sv);
      };

      window.apiRequest('post', `/sensor/${this.onboarding.sensor.sid}`, sensorData).then(res => {
        if (res.type === 'error') {

          this.$saveSensorMessage.addClass('is-error');
          this.$saveSensorMessage.html(res.message);

          this.$saveNameBtn.removeAttr('disabled');
          this.$saveAddAnotherBtn.removeAttr('disabled');

        } else {

          if (redirectToSetup) {
            goToSetupQuickAdd();
          } else {
            SiteMessagesInstance.addMessage('success', 'Successfully set up your Temp Stick');
            window.location.href = window.site.home + '/sensors?id=' + encodeURIComponent(this.onboarding.sensor.sid);
          }

        }
      });

    };

    this.$saveNameBtn.on('click', () => saveSensor(false));
    this.$saveAddAnotherBtn.on('click', () => saveSensor(true));

  }

}